import { CompleteContractDto } from '../contracts/contract-complete.dto';
import { FollowupLiabilityDto, LiabilityDto } from 'services/liabilities/liabilities.service';

export class PaginationDto<T> {
    total?: number;
    data?: T[];
}

export class FollowUpDto {
    id?: number;
    month?: number;
    year?: number;
    rentalPrice?: number;
    upgradeable?: boolean;
    paymentStatus?: FollowUpPaymentStatusEnum;
    payment?: any;
    amountPaid?: number;
    expirationDay?: number;
    followUpStatus?: string;
    total?: number;
}

export class priceDto {
    id?: number;
    price?: number;
}

// Response of the price-update endpoint. The backend re-reads the authoritative follow-up after the
// new price persists and returns the fresh rent and the mora recalculated on it, plus an explicit
// `priceUpdated: true` marker — sent even when the confirmed price equals the previous one. The
// frontend trusts the rent/interest here only when that marker is present.
export interface UpdatePriceResponseDto extends CompleteFollowUpDto {
    priceUpdated?: boolean;
}
export interface ChargeDecisionInputDto {
    dontCharge: boolean;
    expectedPaymentStatus: FollowUpPaymentStatusEnum;
    paymentIntent?: 'pay-rent';
}
export interface ChargeDecisionResponseDto extends CompleteFollowUpDto {
    chargeDecisionApplied?: boolean;
}
export interface CompleteFollowUpDto extends FollowUpDto {
    contract?: CompleteContractDto;
    alias?: string;
    renterName?: string;
    ownerName?: string;
    nextPrice?: number;
    total?: number;
    payment?: any;
    interestPrice?: number;
    dontCharge?: boolean;
    paymentStatus?: FollowUpPaymentStatusEnum;
    liabilities?: FollowupLiabilityDto[];
}

export enum FollowUpPaymentStatusEnum {
    COMPLETE = 'complete',
    PARTIAL = 'partial',
    INCOMPLETE = 'incomplete',
    UNKNOWN = 'unknown',
}
